export const parseURLparams = wantedParams => {
    const location = window.location;

    let res = {
        url: location.href,
    };

    Object.keys(wantedParams).forEach(prop => {
        res[prop] = {};

        let currParams = new URLSearchParams(location[prop].substr(1));

        wantedParams[prop].forEach(param => {
            if (currParams.has(param)) {
                let val = currParams.get(param);

                res[prop][param] = isNaN(val) ? val : parseInt(val);
                currParams.delete(param);
            }
        });

        let replacement = currParams.toString();

        res.url = res.url.replace(
            location[prop],
            replacement ? location[prop].charAt(0) + replacement : ''
        );
    });

    return res;
};



// WEBPACK FOOTER //
// ./src/utils/url-parsers.js